// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "qr-code-reader" + "-" + "dd9cf92a9a6624644d5e" + ".chunk.js";
};